import React, { useState } from "react";
import { Button, ColumnConfig, Text } from "grommet";
import { UserType } from "../types/UserType";
import { useNavigate } from "react-router-dom";
import usersService from "../users.service";
import { useStore } from "../../../../../../../Hooks/useStore";
import EditIconUsers from "../../../../../../../assets/edit.png"
import createuserService from "../CreateUser/createuser.service";

interface EditProfileProps {
  user: UserType;
}

const profileCodeToDisplayName: { [key: string]: string } = {
  crew: "Crew",
  ems: "EMS",
  captain: "Captain",
  admin: "Admin",
  superAdmin: "SuperAdmin",
  dispatch: "Dispatch"
};

const genderFormat = (gender: string) => {
  if (gender === undefined) return "Not Provided";
  switch (gender.toLowerCase()) {
    case "male":
      return "Male";
    case "female":
      return "Female";
    case "others":
      return "Others";
  }
};

const EditProfile: React.FC<EditProfileProps> = ({ user }) => {
  const {rootStore} = useStore();
  let navigate = useNavigate();
       // const {rootStore} = useStore();
       const [isEditFormOpen, setIsEditFormOpen] = useState(false)
       const editProfileUsers = (user_name: string) => {
        //const { rootStore } = useStore(); // Assuming you have access to your rootStore
      
        rootStore.adminStore.handleEditProfileUser(true);
        rootStore.adminStore.handleEditProfileUsername(user_name);

      
        try {
          // Fetch user data by username
          usersService.listUsersByUsername(user_name).then((userResponse) => {
            if (userResponse.length > 0) {
              rootStore.adminStore.handleUserName(userResponse[0]?.username ?? "");
              rootStore.adminStore.handleEmail(userResponse[0]?.email ?? "");
              rootStore.adminStore.handleFirstName(userResponse[0]?.name ?? "");
              rootStore.adminStore.handleFamilyname(userResponse[0]?.family_name ?? "");
              rootStore.adminStore.handleCustomType(userResponse[0]?.["custom:type"] ?? "");
              rootStore.adminStore.handleGender(userResponse[0]?.gender ?? "");
              rootStore.adminStore.handleUserStatus(userResponse[0]?.userStatus ?? "");
              rootStore.adminStore.handleSelectedUser([userResponse[0]?.username ?? ""]);

              setIsEditFormOpen(true); // Open the edit form
      
              // Fetch additional data using createuserService.getOrgByUserName
              createuserService.getOrgByUserName(user_name).then((orgResponse) => {
                //alert(JSON.stringify(orgResponse))
                // Assuming orgResponse contains organization data
                rootStore.adminStore.handleOrganization(orgResponse.id);
                
                // Optionally handle other properties from orgResponse if needed
              }).catch((orgError) => {
                console.error("Error fetching organization data:", orgError);
              });
            } else {
              console.log("No user found with username:", user_name);
            }
          });
        } catch (error) {
          console.log("Error fetching user data:", error);
        }
      };

  return(
      <Button style={{display: "flex",
        width: "28px",
        height: "28px",
        padding: "1px",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        borderRadius: "6px",
        border: "1px solid #357EFF",
      marginLeft: 10}}
      className="cell-container"
      onClick={() => editProfileUsers(user.username)}
      // onClick={() => toggleEditForm(user.id)}
      >
              {/* <Button
                primary
                color={"brand-1"}
                label="Edit"
                onClick={()=> navigate(`/edit-profile?username=${user.username}`)}
              /> */}
              <img style={{width: "15.98px",
height: "16px",
flexShrink: "0",
fill: "#357EFF"}}src={EditIconUsers}/>
            </Button>
  )
}

const ResendMail: React.FC<EditProfileProps> = ({ user }) => {
  const {rootStore} = useStore();
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  

  

  const ResendEmail = async (user: UserType) => {
    if (user) {
      try {
        let result = await usersService.resendMail(user.username, user.email);
        if (result == "Email Sent") {
          rootStore.notificationToastStore.showNotification("Email send successfully.",false, 3000);
        } else if (result == "error") {
          rootStore.notificationToastStore.showNotification("There was an error while attempting to send the email.",true, 3000);
        } else {}
      } catch (error) {
        console.log('error in resend mail', error);
      }
    }
  }
  

  return(
      <div className="cell-container">
              <Button
              
                style={{  display: "flex",
                  padding: "7px 12px",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "6px",
                  border: "1px solid #357EFF",
                  background: "#FFF",
                  color: "#357EFF",
                  textAlign: "center",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: "600",
                  lineHeight: "14px" /* 116.667% */}}
                primary
                color={"brand-1"}
                label="Resend Email"
                onClick={()=> ResendEmail(user)}
              />
            </div>
  )
}


export const UserTableColumns: ColumnConfig<UserType>[] = [
  {
    property: "username",
    header: "Username",
    primary: true,
    render: (item) => {
      return <div className="cell-container">{item.username}</div>;
    },
  },
  {
    property: "email",
    header: "Email",
    primary: true,
    render: (item) => {
      return <div className="cell-container">{item.email}</div>;
    },
  },
  {
    property: "name",
    header: "Name",
    primary: true,
    render: (item) => {
      return <div className="cell-container">{item.name}</div>;
    },
  },
  {
    property: "family_name",
    header: "Last Name",
    primary: true,
    render: (item) => {
      return <div className="cell-container">{item.family_name}</div>;
    },
  },
  {
    property: "gender",
    header: "Gender",
    primary: true,
    render: (item) => {
      return (
        <div className="cell-container">
          {genderFormat(item.gender as string)}
        </div>
      );
    },
  },
  {
    property: "custom:type",
    header: "Profile",
    primary: true,
    render: (item) => {
      return (
        <div className="cell-container">
          {profileCodeToDisplayName[item["custom:type"] as string]}
        </div>
      );
    },
  },
  {
    property: "enabled",
    header: <Text textAlign="center">Status</Text>,
    primary: true,
    render: (item) => {
    
      return (
        <div
          className={
            item.enabled ? "cell-container-enabled" : "cell-container-disabled"
          }
        >
          {item.enabled ? "Enabled" : "Disabled"}
        </div>
      );
    },
  },
  {
    align:"center",
    property: "userStatus",
    header: <Text textAlign="center">Confirmation Status </Text>,
    primary: true,
    render: (item) => {
      return <div style={{width:"10%"}}className="cell-container lastnameColumn">{item.userStatus}</div>;
    },
  },
  {
    property: "",
    header:  <Text textAlign="center">Edit Profile</Text>,
    primary: true,
    render: (item) => {
      // const {rootStore} = useStore();
      // const [isEditFormOpen, setIsEditFormOpen] = useState(false);
      // const toggleEditForm = (UserId:UserType[]) => {
      //   try {
      //     createuserService.getOrgByUserName(UserId).then((userResponse) => {
      //       rootStore.adminStore.handleUserName(userResponse.username);
      //       rootStore.adminStore.handleEmail(userResponse.email);
      //       rootStore.adminStore.handleFirstName(userResponse.name);
      //       rootStore.adminStore.handleFamilyname(userResponse.familyName);
      //       rootStore.adminStore.handleCustomType(userResponse.customType);
      //       rootStore.adminStore.handleGender(userResponse.gender);
      //       rootStore.adminStore.handleOrganization(userResponse.organization.id);
      //       // rootStore.adminStore.handleSpecificFlights(usersResponse);
    
      //       setIsEditFormOpen(!isEditFormOpen);
      //       rootStore.adminStore.handleEditProfileUser(true)
      //     });
      //   } catch (error) {
      //     console.log(error);
      //   }
      // };
      // return(<div style={{display: 'flex',flexDirection: 'row',alignItems:'center',justifyContent: 'center'}}><ResendMail user={item} /><EditProfile user={item}/></div>)}
      return(<div style={{display: 'flex',flexDirection: 'row',alignItems:'center',justifyContent: 'center'}}><EditProfile user={item}/></div>)}
  }
];
